import { Box, FormHelperText, Stack } from '@mui/material';
import React, { useEffect, useState } from 'react';

import ButtonElement from '@/views/elements/button/ButtonElement';
import CheckboxElement from '@/views/elements/checkBox/CheckBox';
import classNames from 'classnames/bind';
import { produce } from 'immer';
import { DataOnParents, KeyDataParents } from './ConfigCopy';
import styles from './Step1.scss';
import { cloneDeep } from 'lodash';
import InputNumber from '@/views/elements/Inputs/InputNumber';
import { useTranslation } from 'react-i18next';
import { getMasterCopyConfig } from '@/controllers/gridManager/followerTransManager/followerTransManager';
import { doInit2factorAuth, useCosInfo } from '@/controllers/gridManager/accountsManager/accountManager';
import { setStateLoadingAction } from '@/stores/dataManager/Actions/appAction';
const cx = classNames.bind(styles);

export type PropsStep = {
    close: () => void,
    back: () => void,
    next: () => void,
    handleSaveDataOnParents: (key: KeyDataParents, data: {}) => void
    dataOnParents: DataOnParents,
    data: any
}

type InputValueNumber = string | number | undefined

type InputValueCheckBox = boolean

type InputType = "input" | "checkbox"

type ObjectInputValue = {
    key: Field
    type: "input",
    value: InputValueNumber
    isError: boolean
    contextError: string
} | {
    key: Field
    type: "checkbox",
    value: InputValueCheckBox
    isError: boolean
    contextError: string
}

type Field = 'valueStopLoss' | 'valueStopProfit' | 'valueOverBuyPrice' | 'valueOverSellPrice'
    | 'isStopLoss' | 'isStopProfit' | 'isOverBuyPrice' | 'isOverSellPrice'

type DataInputValue = Record<Field, ObjectInputValue>

const Step1 = ({ close, back, next, handleSaveDataOnParents, dataOnParents, data }: PropsStep) => {
    const { t } = useTranslation()
    const { cosInfo } = useCosInfo()
    const { Step1 }: { Step1: any } = dataOnParents
    const { dataMasterTrade } = data
    // console.log('ha_check_dataMasterTrade', dataMasterTrade)

    const masterAccount = dataMasterTrade?.mtacctno ?? null

    const defaultValueStopLoss: ObjectInputValue = {
        key: 'valueStopLoss',
        value: 20,
        type: "input",
        isError: false,
        contextError: '',
    }

    const defaultValueStopProfit: ObjectInputValue = {
        key: 'valueStopProfit',
        value: 20,
        type: "input",
        isError: false,
        contextError: '',
    }

    const defaultValueOverBuyPrice: ObjectInputValue = {
        key: 'valueOverBuyPrice',
        value: 5,
        type: "input",
        isError: false,
        contextError: '',
    }

    const defaultValueOverSellPrice: ObjectInputValue = {
        key: 'valueOverSellPrice',
        value: 5,
        type: "input",
        isError: false,
        contextError: '',
    }

    const defaultIsStopLoss: ObjectInputValue = {
        key: 'isStopLoss',
        value: true,
        type: "checkbox",
        isError: false,
        contextError: '',
    }

    const defaultIsStopProfit: ObjectInputValue = {
        key: 'isStopProfit',
        value: true,
        type: "checkbox",
        isError: false,
        contextError: '',
    }

    const defaultIsOverBuyPrice: ObjectInputValue = {
        key: 'isOverBuyPrice',
        value: true,
        type: "checkbox",
        isError: false,
        contextError: '',
    }

    const defaultIsOverSellPrice: ObjectInputValue = {
        key: 'isOverSellPrice',
        value: true,
        type: "checkbox",
        isError: false,
        contextError: '',
    }

    const [inputValue, setInputValue] = useState<DataInputValue>({
        valueStopLoss: defaultValueStopLoss,
        valueStopProfit: defaultValueStopProfit,
        valueOverBuyPrice: defaultValueOverBuyPrice,
        valueOverSellPrice: defaultValueOverSellPrice,
        isStopLoss: defaultIsStopLoss,
        isStopProfit: defaultIsStopProfit,
        isOverBuyPrice: defaultIsOverBuyPrice,
        isOverSellPrice: defaultIsOverSellPrice,
    })


    const handleChangeInput = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, key: Field, type: InputType) => {
        if (type === 'input') {
            setInputValue(
                produce((draft: DataInputValue) => {
                    draft[key].value = event.target.value
                    const result = validByKey(key, event.target.value)
                    // console.log('ha_check_result111', { result, key, value: event.target.value })
                    if (result) {
                        draft[key].isError = result.isError
                        draft[key].contextError = result.contextError
                    }
                })
            );
        }
    };

    const handleChangeCheckBox = (event: React.ChangeEvent<HTMLInputElement>, key: Field, type: InputType) => {
        if (type === 'checkbox') {
            setInputValue(
                produce((draft: DataInputValue) => {
                    // For checkbox, value is boolean
                    draft[key].value = event.target.checked;
                    const result = validByKey(key, event.target.checked);
                    if (result.isError === true) {
                        draft[key].isError = result.isError;
                        draft[key].contextError = result.contextError;
                    } else {
                        draft[key].isError = result.isError
                        draft[key].contextError = result.contextError
                    }
                })
            );
        }
    };

    const validByKey = (key: Field, value: any) => {
        const result = {
            key: key,
            isError: false,
            contextError: '',
        }

        if (key === 'valueOverBuyPrice' || key === 'valueOverSellPrice') {
            // Qua mua, qua ban
            if (value === '' || Number.parseFloat(value) === 0) {
                result.isError = true
                result.contextError = t("copytrade.copyMaster.notEmpty")
            } else if (Number.parseFloat(value) > 80) {
                result.isError = true
                result.contextError = t("copytrade.copyMaster.invalidRate")
            }
        }


        if (key === 'valueStopLoss' || key === 'isStopProfit') {
            // Qua mua, qua ban
            if (value === '' || Number.parseFloat(value) === 0) {
                result.isError = true
                result.contextError = t("copytrade.copyMaster.notEmpty")
            }
        }

        return result
    }

    const validationWhenNext = () => {
        let arrayError = []
        for (const property in inputValue) {
            const result = validByKey(property as Field, inputValue[property as Field].value)
            if (result.isError === true) {
                arrayError.push(result)
            }
        }
        setInputValue(
            produce((draft: DataInputValue) => {
                arrayError.forEach(element => {
                    if (element.isError === true) {
                        draft[element.key as Field].isError = element.isError
                        draft[element.key as Field].contextError = element.contextError
                    }
                });
            })
        );
        console.log('ha_check_arrayError', arrayError)
        return arrayError.length === 0 ? false : true
    }

    useEffect(() => {
        if (Step1?.isSaved === true) {
            setInputValue(
                produce((draft: DataInputValue) => {
                    if (Step1?.preData) {
                        Object.assign(draft, Step1.preData);
                    }
                })
            );
        }
    }, [])

    useEffect(() => {
        async function callGetMasterCopyConfig(accountId: string) {
            const { isSuccess, data } = await getMasterCopyConfig({ accountId, masterAccount })
            if (isSuccess) {
                console.log('ha_check_datacallGetMasterCopyConfig', data)
                setInputValue(
                    produce((draft: DataInputValue) => {
                        draft.valueOverBuyPrice.value = data?.buy_range ?? defaultValueOverBuyPrice.value
                        draft.valueOverSellPrice.value = data?.sell_range ?? defaultValueOverSellPrice.value
                        draft.valueStopLoss.value = data?.cut_loss_rate ?? defaultValueStopLoss.value
                        draft.valueStopProfit.value = data?.take_profit_rate ?? defaultValueStopProfit.value
                    })
                );
            }
        }
        callGetMasterCopyConfig(cosInfo?.refaccount ?? null)
    }, [masterAccount])

    const handleNext = async () => {

        const isError = validationWhenNext()

        if (isError) return;

        const cloneInputValue = cloneDeep(inputValue)

        if (inputValue.isOverBuyPrice.value === false) {
            cloneInputValue.valueOverBuyPrice.value = defaultValueOverBuyPrice.value
        }

        if (inputValue.isOverSellPrice.value === false) {
            cloneInputValue.valueOverSellPrice.value = defaultValueOverSellPrice.value
        }

        if (inputValue.isStopLoss.value === false) {
            cloneInputValue.valueStopLoss.value = defaultValueStopLoss.value
        }

        if (inputValue.isStopProfit.value === false) {
            cloneInputValue.valueStopProfit.value = defaultValueStopProfit.value
        }

        setStateLoadingAction(true)
        const { isSuccess, data } = await doInit2factorAuth()
        setStateLoadingAction(false)
        if (isSuccess && Object.hasOwn(data, 'transactionId')) {
            handleSaveDataOnParents("Step1", { isSaved: true, preData: cloneInputValue });

            handleSaveDataOnParents("dataVerify", data);
            next()
        }
    }


    return (
        <Box className="Step1">
            <Stack
                direction={"column"}
                spacing={2}
            >
                <Stack
                    direction={"row"}
                    justifyContent={"space-between"}
                    spacing={1}
                >
                    <Stack
                        direction={"column"}
                        sx={{ width: "100%" }}
                    >

                        <Stack
                            direction={"row"}
                            sx={{ width: "100%" }}
                            alignItems={"center"}
                        >
                            <Box>
                                <CheckboxElement
                                    sx={{ marginLeft: "-10px" }}
                                    checked={inputValue.isStopProfit.value} onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeCheckBox(e, 'isStopProfit', 'checkbox')}
                                    inputProps={{ 'aria-label': 'controlled' }} />
                            </Box>
                            <Box >
                                {t("copytrade.copyMaster.stopCopyWhenProfit")}
                            </Box>
                        </Stack>

                        <Box>
                            <InputNumber
                                realValue={inputValue.valueStopProfit.value as InputValueNumber}
                                handleChangeInput={(e) => handleChangeInput(e, 'valueStopProfit', 'input')}
                                disabled={!(inputValue.isStopProfit.value as boolean)}
                                maxValue={999999999999}
                                minValue={0}
                                decimalScale={2}
                                id="valueStopProfit"
                                endAdornment='%'
                                error={inputValue.valueStopProfit.isError}
                            />
                            {inputValue.valueStopProfit.isError === true &&
                                <FormHelperText error id="valueStopProfit">
                                    {inputValue.valueStopProfit.contextError}
                                </FormHelperText>
                            }
                        </Box>
                    </Stack>

                    <Stack
                        direction={"column"}
                        sx={{ width: "100%" }}
                    >

                        <Stack
                            direction={"row"}
                            sx={{ width: "100%" }}
                            alignItems={"center"}
                        >
                            <Box>
                                <CheckboxElement
                                    sx={{ marginLeft: "-10px" }}
                                    checked={inputValue.isStopLoss.value} onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeCheckBox(e, 'isStopLoss', 'checkbox')}
                                    inputProps={{ 'aria-label': 'controlled' }} />
                            </Box>
                            <Box >
                                {t("copytrade.copyMaster.stopCopyWhenLoss")}
                            </Box>
                        </Stack>

                        <Box>
                            <InputNumber
                                realValue={inputValue.valueStopLoss.value as InputValueNumber}
                                handleChangeInput={(e) => handleChangeInput(e, 'valueStopLoss', 'input')}
                                disabled={!(inputValue.isStopLoss.value as boolean)}
                                maxValue={999999999999}
                                minValue={0}
                                decimalScale={2}
                                id="valueStopLoss"
                                endAdornment='%'
                                error={inputValue.valueStopLoss.isError}
                            />
                            {inputValue.valueStopLoss.isError === true &&
                                <FormHelperText error id="valueStopLoss">
                                    {inputValue.valueStopLoss.contextError}
                                </FormHelperText>
                            }
                        </Box>
                    </Stack>

                </Stack>

                <Stack
                    direction={"row"}
                    justifyContent={"space-between"}
                    spacing={1}
                >
                    <Stack
                        direction={"column"}
                        sx={{ width: "100%" }}
                    >

                        <Stack
                            direction={"row"}
                            sx={{ width: "100%" }}
                            alignItems={"center"}
                        >
                            <Box>
                                <CheckboxElement
                                    sx={{ marginLeft: "-10px" }}
                                    checked={inputValue.isOverBuyPrice.value} onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeCheckBox(e, 'isOverBuyPrice', 'checkbox')}
                                    inputProps={{ 'aria-label': 'controlled' }} />
                            </Box>
                            <Box >
                                {t("copytrade.copyMaster.overBuy")}
                            </Box>
                        </Stack>

                        <Box>
                            <InputNumber
                                realValue={inputValue.valueOverBuyPrice.value as InputValueNumber}
                                handleChangeInput={(e) => handleChangeInput(e, 'valueOverBuyPrice', 'input')}
                                id="valueOverBuyPrice"
                                disabled={!inputValue.isOverBuyPrice.value as boolean}
                                decimalScale={2}
                                maxValue={999999999999}
                                minValue={0}
                                endAdornment='%'
                                error={inputValue.valueOverBuyPrice.isError}
                            />
                            {inputValue.valueOverBuyPrice.isError === true &&
                                <FormHelperText error id="valueOverBuyPrice">
                                    {inputValue.valueOverBuyPrice.contextError}
                                </FormHelperText>
                            }

                        </Box>
                    </Stack>

                    <Stack
                        direction={"column"}
                        sx={{ width: "100%" }}
                    >

                        <Stack
                            direction={"row"}
                            sx={{ width: "100%" }}
                            alignItems={"center"}
                        >
                            <Box>
                                <CheckboxElement
                                    sx={{ marginLeft: "-10px" }}
                                    checked={inputValue.isOverSellPrice.value} onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeCheckBox(e, 'isOverSellPrice', 'checkbox')}
                                    inputProps={{ 'aria-label': 'controlled' }} />
                            </Box>
                            <Box >
                                {t("copytrade.copyMaster.overSell")}
                            </Box>
                        </Stack>

                        <Box >
                            <InputNumber
                                realValue={inputValue.valueOverSellPrice.value as InputValueNumber}
                                handleChangeInput={(e) => handleChangeInput(e, 'valueOverSellPrice', 'input')}
                                id="valueOverSellPrice"
                                disabled={!inputValue.isOverSellPrice.value}
                                maxValue={999999999999}
                                minValue={0}
                                decimalScale={2}
                                endAdornment='%'
                                error={inputValue.valueOverSellPrice.isError}
                            />
                            {inputValue.valueOverSellPrice.isError === true &&
                                <FormHelperText error id="valueOverSellPrice">
                                    {inputValue.valueOverSellPrice.contextError}
                                </FormHelperText>
                            }
                        </Box>
                    </Stack>

                </Stack>

                <Stack
                    direction={"row"}
                    spacing={2}
                    justifyContent={"center"}
                >
                    <ButtonElement customType="Secondary" className={cx("btn-register")} variant="contained"
                        onClick={() => close()} >{t("copytrade.common.close")}</ButtonElement>
                    <ButtonElement customType="Primary" className={cx("btn-register")} variant="contained"
                        onClick={
                            () => handleNext()
                        } >{t("copytrade.common.next")}</ButtonElement>
                </Stack>
            </Stack>
        </Box >
    )
}

export default Step1